import { genMuiThemes } from 'clnt-common';

                             // LIGHT
const ltp    = '#0a3097';    // primary       : nav bar bg/footer bg/submenubar bg/toaster bg/action btn/active tab/submit btn/PWA btn/ color ALSO used in manifest.webmanifest: theme_color
const lts    = '#bc0b08';    // secondary     : button bg/create form btn/SignIn/ also used in the manifest.webmanifest
const ltpnl  = '#ebe2f9';    // panel ?       : ???
const ltbpnl = '#d9def5';    // back panel    : (The same is used in manifest.webmanifest: background_color)
const ltcpnl = '#eef5f9';    // content panel : surface bg on which content is layed (The same is used in manifest.webmanifest: background_color)

                             // DARK
const dkp    = '#757272';    // primary       : 
const dks    = '#bc0b08';    // secondary     : 
const dkpnl  = '#232323';    // panel ?       : 
const dkbpnl = '#0c1631';    // back panel    : 
const dkcpnl = '#080404';    // content panel : 

const options = {
  fontHeader :      'Albra',
  fontText :        'Inter',

  primaryLight:     ltp,
  secondaryLight:   lts,
  panelBgLight:     ltpnl,
  backpanelBgLight: ltbpnl,
  contentpanelBgLight: ltcpnl,

  primaryDark:      dkp,
  secondaryDark:    dks,
  panelBgDark:      dkpnl,
  backpanelBgDark:  dkbpnl,
  contentpanelBgDark:  dkcpnl,

  pagePadding : 1,
  pageGap : 0,

  // For use within pages.ts (rendered via PageContentFormat.jsx)
  // 5 sets of areas.
  areaLight: [{ panel: '', border: '#cccccc' },  // about
              { panel: '', border: '#3845f3' },  // service:matrix
              { panel: '#e8eafb', border: '' },  // service:chat
              { panel: '#af9d9d', border: '#cccffa' },  // service: *
              { panel: '', border: '' }],  
  areaDark:  [{ panel: '', border: '' },  
              { panel: '', border: '' },  
              { panel: '', border: '' },  
              { panel: '', border: '' },  
              { panel: '', border: '' }],

  borderLight : '#ff0000',      // Used for FORM container border
  borderDark : '#777777',       // Used for FORM container border
};

export { themes };
let themes = genMuiThemes(options);


